module.exports = __webpack_public_path__ + "img/bk3.1696f91e.jpg";